import React from "react";

export default function (props) {

    let style = props.style || {};
    style.borderRadius = "6px";
    let btnClassName = props.btnClassName || '';
    btnClassName += " btn btn-transparent btn-default text-outline";

    return (
        <div className="transparent-black-bg" style={style}>
            <button className={btnClassName} onClick={props.onClick}>
                {props.children}
            </button>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/js/GenericBlackBtn.js